import { render, staticRenderFns } from "./WebhookTab.vue?vue&type=template&id=d28a80a6&"
import script from "./WebhookTab.vue?vue&type=script&lang=js&"
export * from "./WebhookTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports